import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge, SpaceDiv } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token, getUserInfoCompanyId } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT, SELECT_VAL_TYPE_STRING } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchBrLine, SearchDate, SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getGameList, api_getScorerList } from '../../../../../api/MyStat/apiGame';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { game_status_arr, GAME_STATUS_CANCEL, GAME_STATUS_FINISH, GAME_STATUS_KEEP, GAME_STATUS_SCHEDULED, get_game_status_string, get_scoring_status_string, KEY_GAME_ACTIVATION, KEY_GAME_ACTIVATION_STRING, KEY_GAME_DATE_END, KEY_GAME_DATE_END_STRING, KEY_GAME_DATE_START, KEY_GAME_DATE_START_STRING, KEY_GAME_NO, KEY_GAME_NO_STRING, KEY_GAME_STATUS, KEY_GAME_STATUS_STRING, KEY_GAME_TYPE, KEY_GAME_TYPE_STRING, KEY_LEAGUE_ASSOCIATION, KEY_LEAGUE_ASSOCIATION_STRING, KEY_SCORER, KEY_SCORER_STRING, KEY_SCORING_STATUS, KEY_SCORING_STATUS_STRING, KEY_TEAM_NAME, KEY_TEAM_NAME_STRING, ReqGameList, scoring_status_arr, SCORING_STATUS_COMPLETE_REVIEW, SCORING_STATUS_NOT_RECORDED, SCORING_STATUS_ON_RECORD, SCORING_STATUS_RECORD_REVISION, SCORING_STATUS_UNDER_REVIEW } from '../../../../../item/MyStat/ItemGame';
import { ACTIVATION_ENABLE, ACTIVATION_SELECT_ALL, ACTIVATION_SELECT_ENABLE, search_activation_attr, get_activation_string, get_activation_color, ACTIVATION_DISABLE } from '../../../../../item/MyStat/ItemMyStatBase';
import { api_getLeagueGameTypeList, api_getLeagueListEnable } from '../../../../../api/MyStat/apiLeague';

export function GameList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")
    const [league_association_List, set_league_association_List] = useState([])
    const [league_association_arr, set_league_association_arr] = useState(undefined)
    const [game_type_arr, set_game_type_arr] = useState([])
    const [scorer_arr, set_scorer_arr] = useState([])

    const [game_No, set_game_No] = useState("")
    const [league_association, set_league_association] = useState("J61qWKmDQnVG3VoARPPgm4hAWuaCai0")
    const [game_type, set_game_type] = useState("")
    const [game_activation, set_game_activation] = useState(ACTIVATION_SELECT_ALL)
    const [team_name, set_team_name] = useState("")
    const [game_date_start, set_game_date_start] = useState()
    const [game_date_end, set_game_date_end] = useState("")
    const [scorer, set_scorer] = useState("")
    const [game_status, set_sgame_status] = useState('')
    const [scoring_status, set_scoring_status] = useState('')

    const [searchItems, setSearchItems] = useState([])

    const [teamList, setGameList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(15)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    // const [mReqGameList, setReqGameList] = useState({})

    const [list_obj, set_list_obj] = useState({})

    const [searchItem, set_searchItem] = useState()


    useEffect(() => {
        get_ScorerList()
        get_league_association()
    }, [])
    useEffect(() => {
        if (league_association_arr !== undefined)
        var searchItems = [
            [
                new SearchInput({
                    key: KEY_GAME_NO,
                    val: game_No,
                    defaultVal: '',
                    title: KEY_GAME_NO_STRING,
                    col: 3
                }),
                new SearchSelect({
                    key: KEY_LEAGUE_ASSOCIATION,
                    val: league_association,
                    defaultVal: "J61qWKmDQnVG3VoARPPgm4hAWuaCai0",
                    valType: SELECT_VAL_TYPE_STRING,
                    title: KEY_LEAGUE_ASSOCIATION_STRING,
                    col: 3,
                    attr: league_association_arr,
                    hasBlank: false,
                    // blankOption: '全部'
                }),
                new SearchSelect({
                    key: KEY_GAME_TYPE,
                    val: game_type,
                    defaultVal: "",
                    valType: SELECT_VAL_TYPE_STRING,
                    title: KEY_GAME_TYPE_STRING,
                    col: 3,
                    attr: game_type_arr,
                    hasBlank: true,
                    blankOption: '全部',
                    n: 'game_type_name',
                    v: 'game_type',
                }),
                new SearchSelect({
                    key: KEY_GAME_ACTIVATION,
                    val: game_activation,
                    defaultVal: ACTIVATION_SELECT_ALL,
                    valType: SELECT_VAL_TYPE_INT,
                    title: KEY_GAME_ACTIVATION_STRING,
                    col: 3,
                    attr: search_activation_attr,
                }),
                new SearchBrLine(),
                new SearchInput({
                    key: KEY_TEAM_NAME,
                    val: team_name,
                    defaultVal: '',
                    title: KEY_TEAM_NAME_STRING,
                    col: 3
                }),
                new SearchDate({
                    key: KEY_GAME_DATE_START,
                    val: game_date_start,
                    defaultVal: game_date_start,
                    title: KEY_GAME_DATE_START_STRING,
                    col: 3
                }),
                new SearchDate({
                    key: KEY_GAME_DATE_END,
                    val: game_date_end,
                    defaultVal: '',
                    title: KEY_GAME_DATE_END_STRING,
                    col: 3
                }),
                new SearchBrLine(),
                new SearchSelect({
                    key: KEY_GAME_STATUS,
                    val: game_status,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_INT,
                    title: KEY_GAME_STATUS_STRING,
                    col: 3,
                    attr: game_status_arr,
                    hasBlank: true,
                }),
                new SearchSelect({
                    key: KEY_SCORER,
                    val: scorer,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_STRING,
                    title: KEY_SCORER_STRING,
                    col: 3,
                    attr: scorer_arr,
                    n: 'nickName',
                    v: 'accountId',
                    hasBlank: true,
                }),
                new SearchSelect({
                    key: KEY_SCORING_STATUS,
                    val: scoring_status,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_INT,
                    title: KEY_SCORING_STATUS_STRING,
                    col: 3,
                    attr: scoring_status_arr,
                    hasBlank: true,
                }),
            ],
            // new SearchBrLine()
        ]
        // console.log('game_date_start')
        // console.log(game_date_start)
        // console.log(league_association)
        setSearchItems(searchItems)
    }, [league_association_arr, game_type_arr, scorer_arr, team_name, game_activation, league_association, scorer])

    useEffect(() => {
        if (id !== undefined && id !== tokenId && league_association_arr !== undefined && league_association != undefined && league_association !='') {

        // console.log('game_date_start')
        // console.log(game_date_start)
        // console.log(league_association)
            var url = getval2Token("url", id)
            // console.log('url')
            // console.log(url)
            // console.log('url')
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqGameList = new ReqGameList({ start, limit, league_association, game_date_start })
            if (url === "") {
                toSearch({ searchItem: mReqGameList, page: url.page })
            } else {
                mReqGameList.fromJson(url)
                console.log(mReqGameList)
                // set_team_name(mReqGameList.team_name)
                set_league_association(mReqGameList.league_association)
                set_game_activation(mReqGameList.game_activation)
                toSearch({ searchItem: mReqGameList, page: url.page })
            }
        }
    }, [id, league_association_arr])

    useEffect(() => {
        var contents = []
        teamList.forEach(item => {
            // console.log(item)
            var content = []
            content.push(setTDLink({ link: 'Game_Edit', content: item.game_No, key: 'GameEdit', val: item }))
            content.push(setTD({ content: item.game_activation === 0 ? <s>{item.game_type_name}</s> : item.game_type_name }))

            var days = moment().diff(moment(item.game_date), 'days')
            var game_date_color
            if (days > 0) {
                if (item.game_date === SCORING_STATUS_COMPLETE_REVIEW) {
                    game_date_color = get_activation_color(ACTIVATION_ENABLE)
                } else {
                    game_date_color = get_activation_color(ACTIVATION_DISABLE)
                }
            }
            content.push(setTD({ content: moment(item.game_date).format('YYYY/MM/DD'), color: game_date_color }))

            var home_team_color
            if (item.scoring_status === SCORING_STATUS_COMPLETE_REVIEW) {
                home_team_color = item.home_score > item.away_score ? get_activation_color(ACTIVATION_DISABLE) : null
            }
            content.push(setTD({ content: item.home_team_name, color: home_team_color }))
            content.push(setTD({ content: item.scoring_status === SCORING_STATUS_NOT_RECORDED ? 'N/A' : item.home_score }))
            var away_team_color
            if (item.scoring_status === SCORING_STATUS_COMPLETE_REVIEW) {
                away_team_color = item.home_score < item.away_score ? get_activation_color(ACTIVATION_DISABLE) : null
            }
            content.push(setTD({ content: item.away_team_name, color: away_team_color }))
            content.push(setTD({ content: item.scoring_status === SCORING_STATUS_NOT_RECORDED ? 'N/A' : item.away_score }))

            var game_status_color
            if (item.game_status === GAME_STATUS_SCHEDULED) {
                game_status_color = 'danger'
            } else if (item.game_status === GAME_STATUS_CANCEL) {
                game_status_color = 'info'
            } else if (item.game_status === GAME_STATUS_KEEP) {
                game_status_color = 'warning'
            } else if (item.game_status === GAME_STATUS_FINISH) {
                game_status_color = 'muted'
            }
            content.push(setTD({ content: get_game_status_string(item.game_status), color: game_status_color }))
            content.push(setTD({ content: item.scorer_name }))

            var scoring_status_color
            if (item.scoring_status === SCORING_STATUS_NOT_RECORDED) {
                scoring_status_color = 'danger'
            } else if (item.scoring_status === SCORING_STATUS_ON_RECORD) {
                scoring_status_color = 'success'
            } else if (item.scoring_status === SCORING_STATUS_UNDER_REVIEW) {
                scoring_status_color = 'warning'
            } else if (item.scoring_status === SCORING_STATUS_COMPLETE_REVIEW) {
                scoring_status_color = 'info'
            } else if (item.scoring_status === SCORING_STATUS_RECORD_REVISION) {
                scoring_status_color = 'muted'
            }
            content.push(setTD({ content: get_scoring_status_string(item.scoring_status), color: scoring_status_color }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('賽程編號', 1),
                new TableListTitle('賽事種類', 1),
                new TableListTitle('比賽日期', 1),
                new TableListTitle('主場球隊', 2),
                new TableListTitle('得分', 1),
                new TableListTitle('客場球隊', 2),
                new TableListTitle('得分', 1),
                new TableListTitle('比賽狀態', 1),
                new TableListTitle('紀錄員', 1),
                new TableListTitle('紀錄狀態', 1),
            ],
            contents
        }

        set_list_obj(lb)

    }, [teamList])

    const onChange = (key, val) => {
        console.log(key)
        console.log(val)
        switch (key) {
            case KEY_GAME_NO:
                set_game_No(val)
                break;
            case KEY_LEAGUE_ASSOCIATION:
                var filterEmpty = league_association_List.filter((item) => {
                    return item.league_id === val;
                });
                console.log(filterEmpty[0].game_types)
                set_game_type_arr(filterEmpty[0].game_types)
                set_league_association(val)
                break;
            case KEY_GAME_TYPE:
                set_game_type(val)
                break;
            case KEY_GAME_ACTIVATION:
                set_game_type(val)
                break;
            case KEY_TEAM_NAME:
                set_team_name(val)
                break;
            case KEY_GAME_DATE_START:
                set_game_date_start(val)
                break;
            case KEY_GAME_DATE_END:
                set_game_date_end(val)
                break;
            case KEY_GAME_STATUS:
                set_sgame_status(val)
                break;
            case KEY_SCORER:
                set_scorer(val)
                break;
            case KEY_SCORING_STATUS:
                set_scoring_status(val)
                break;

            default:
                break;
        }
    }

    // const onChange = (jsDate, dateString) => {
    //     //console.log(jsDate)
    //     //console.log(dateString)
    //     if (dateString === "Invalid date") {
    //       setBirthError(true)
    //     } else {
    //       setBirthError(false)
    //       set_player_DOB(dateString)
    //     }
    //   }

    function get_ScorerList() {
        api_getScorerList({
            companyId: getUserInfoCompanyId(),
            success: (obj => {
                console.log(obj)
                set_scorer_arr(obj.list)
            }),
            failure: (err) => {
            }
        })
    }

    function get_league_association() {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        api_getLeagueGameTypeList({
            success: (obj) => {
                console.log(obj)
                // var arr = [{ val: "", name: "全部" }]
                var arr = []
                obj.items.forEach(item => {
                    arr.push({ val: item.league_id, name: item.league_name })
                })
                console.log(arr)
                set_game_date_start(moment().add(-8, 'd').format('YYYY-MM-DD'))
                set_league_association('J61qWKmDQnVG3VoARPPgm4hAWuaCai0')
                set_league_association_arr(arr)
                set_league_association_List(obj.items)
                // if (setIsLoading !== undefined)
                //     setIsLoading(false)
            },
            failure: (err) => {
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            }
        })
    }

    function toActionSearch(searchItems) {
        // console.log(searchItems)
        var mReqGameList = new ReqGameList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    mReqGameList[item.key] = item.val
                })
            }
        })
        // console.log(mReqGameList)
        setSearchItems(searchItems)
        toSearch({ searchItem: mReqGameList })
    }

    function toSearch({ searchItem, page = 1 }) {
        // console.log("toSearch")
        // console.log(searchItem)
        // setIsLoading(false)
        // return;
        var start = (page - 1) * limit;
        setPage(page)
        var mReqGameList = new ReqGameList({ start, limit })
        if (searchItem !== undefined) {
            mReqGameList.fromJson(searchItem)
            mReqGameList.start = start
            mReqGameList.limit = limit
        }
        // setReqGameList(mReqGameList)
        set_searchItem(mReqGameList)
        setVal2Token("url", mReqGameList, id)
        getGameList(mReqGameList)
    }

    function getGameList(mReqGameList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log("getGameList")
        // console.log(mReqGameList)
        // setIsLoading(false)
        // return
        api_getGameList({
            mReqGameList,
            success: (obj) => {
                console.log(obj)
                setGameList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/Game_Add");
    }

    var baseTitle = "球賽列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    <SpaceDiv size={2} />
                    <SpaceDiv size={3} content={<AddButton name={"新增賽事"} action={toAdd} />} />
                    <SpaceDiv size={3} content={<AddButton name={"批次新增賽事"} action={toAdd} />} />

                </div>
            </div>
            <Space />
            <ListBox row={10} lt={limit} lb={list_obj} srl={setGameList} count={count} page={page} sp={toSearch} searchItem={searchItem} />
        </>
    return (
        <>
            <BaseSearchBox action={toActionSearch} items={searchItems} onChange={onChange} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

